
import {
  all, call, fork, put, takeEvery
} from 'redux-saga/effects'
import filter from 'lodash.filter'
import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER
} from '../actions'

import {
  loginUserSuccess,
  registerUserSuccess,
  setUser
} from './actions'
import { setCardList } from '../card/actions'
import { setSynonymousText, setParaphraseText } from '../text/actions'
import api from '../../helpers/Api'
import { NotificationManager } from '../../components/common/react-notifications'
import { store, persistor } from '../store'

const loginWithEmailPasswordAsync = async (email, password) => api.post('auth', { email, password })
  .then(response => response)
  .catch(error => error)

function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, email, password)

    if (loginUser.data && loginUser.data.token) {
      localStorage.setItem('user-token', loginUser.data.token)
      localStorage.setItem('user', JSON.stringify(loginUser.data.user))
      store.dispatch(setUser(loginUser.data.user))
      const { iugu } = loginUser.data.user
      if (iugu && iugu.cards && iugu.cards.length > 0) {
        store.dispatch(setCardList(loginUser.data.user.iugu.cards))
      }
      if (loginUser.data.texts && loginUser.data.texts.length > 0) {
        const synonymous = filter(loginUser.data.texts, { tool: 'synonymous' })
        const paraphrase = filter(loginUser.data.texts, { tool: 'paraphrase' })
        // const summarize = filter(loginUser.data.texts, { tool: 'summarize' })
        // const spintax = filter(loginUser.data.texts, { tool: 'spintax' })

        store.dispatch(setSynonymousText(synonymous))
        store.dispatch(setParaphraseText(paraphrase))
      }
      yield put(loginUserSuccess(loginUser.data.token))
    } else if (loginUser.message && loginUser.message === 'Network Error') {
      NotificationManager.primary('Network Error: Probably Backend Server is offline')
    } else {
      NotificationManager.primary(loginUser.response.data)
    }
  } catch (error) {
    NotificationManager.primary(JSON.stringify(error))
  }
}

const registerWithEmailPasswordAsync = async (name, email, password) => api.put('register', { name, email, password })
  .then(response => response)
  .catch(error => error)

function* registerWithEmailPassword({ payload }) {
  const { name, email, password } = payload.user
  try {
    const registerUser = yield call(registerWithEmailPasswordAsync, name, email, password)

    if (registerUser.data && registerUser.data.token) {
      localStorage.setItem('user-token', registerUser.data.token)
      localStorage.setItem('user', JSON.stringify(registerUser.data.user))
      store.dispatch(setUser(registerUser.data.user))
      yield put(registerUserSuccess(registerUser.data.token))
    } else {
      NotificationManager.error(registerUser.response.data.message || JSON.stringify(registerUser.response.data))
    }
  } catch (error) {
    NotificationManager.primary(error.message)
  }
}

const logoutAsync = async (history) => {
  localStorage.removeItem('user')
  localStorage.removeItem('user-token')
  setTimeout(() => persistor.purge(), 200)
  history.push('/')
}

function* logout({ payload }) {
  const { history } = payload
  try {
    yield call(logoutAsync, history)
  } catch (error) {
    NotificationManager.primary(JSON.stringify(error))
  }
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword)
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword)
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout)
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser)
  ])
}
